import { Tabs } from "antd"
import View from "../../components/Base/View"
import { useCallback, useEffect, useRef, useState } from "react";
import httpUtil from "../../utils/httpUtil";
import util from "../../utils/util";
import ScrollView from "../../components/Base/ScrollView";
import Block from "../../components/Base/Block";
import CouponItem from "../../components/CouponItem";
import EmptyTip from "../../components/EmptyTip";
import Loading from "../../components/Loading";
import "./myCoupon.scss"

const MyCoupon = () => {

    const columns = ['未使用', '已使用', '已过期'];
    const [currentColumn, setCurrentColumn] = useState<number>(0);
    const [columnCount, setColumnCount] = useState<number[]>([0, 0, 0]);
    const [dataList, setDataList] = useState<any[][]>([[], [], []]);

    const [isLoading, setLoading1] = useState<boolean[]>([false, false, false]);
    const [noMore, setNoMore1] = useState<boolean[]>([false, false, false]);
    const [loadFailed, setLoadFailed1] = useState<boolean[]>([false, false, false]);

    const isSwitchColumn = useRef<boolean>(false);
    const pageNum = useRef<number[]>([1, 1, 1]);


    const loadList = useCallback((isRefresh: boolean, index: number) => {
        const setLoading = (index: number, loading: boolean) => {
            setLoading1((pre: boolean[]) => {
                const newList = pre.slice(0);
                newList[index] = loading;
                return newList;
            })
        }
        const setNoMore = (index: number, loading: boolean) => {
            setNoMore1((pre: boolean[]) => {
                const newList = pre.slice(0);
                newList[index] = loading;
                return newList;
            })
        }
        const setLoadFail = (index: number, loading: boolean) => {
            setLoadFailed1((pre: boolean[]) => {
                const newList = pre.slice(0);
                newList[index] = loading;
                return newList;
            })
        }

        if (!isRefresh && (isLoading[index] || noMore[index])) {
            return
        }
        if (isRefresh) {
            pageNum.current[index] = 1

            setNoMore(index, false)
            setLoadFail(index, false)
        }
        setLoading(index, true)
        httpUtil.link(
            {
                apiName: 'discountget',
                DiscountStatus: index + 1,
                Page: pageNum.current[index],
                PageSize: 10,
            },
            'GET',
            {},
            true,
            function (success: boolean, res: any, tips: string) {
                if (success) {
                    var result = res.data.Content
                    // 個列表數量
                    if (isRefresh) {
                        setColumnCount([
                            result.ValidDiscountCount,
                            result.UsedDiscountCount,
                            result.InvalidDiscountCount,
                        ])
                    }
                    if (result.Discounts.length > 0) {
                        pageNum.current[index] = pageNum.current[index] + 1
                    } else {
                        setNoMore(index, true)
                    }
                    var listArray = dataList

                    // 對時間進行處理
                    result.Discounts.forEach(function (item: any) {
                        item.StartDate = util.getTimeArry(item.StartDate)
                        item.EndDate = util.getTimeArry(item.EndDate)
                    })
                    listArray[index] = isRefresh
                        ? result.Discounts
                        : listArray[index].concat(result.Discounts)
                    setDataList(listArray)
                } else {
                    setLoadFail(index, true)
                }
                setLoading(index, false)
            }
        )
    }, [isLoading, noMore, pageNum, dataList]);


    useEffect(()=>{
        document.title = "我的优惠券";
        if (dataList[currentColumn].length == 0) {
            loadList(true, currentColumn)
          }
    }, [currentColumn, dataList])

    return <View
        className="mycoupon-page"
    >
        <View className="container ">
            <View className="main-container">
                <Tabs
                    centered
                    style={{
                        height: "100%",
                        overflow: "hidden"
                    }}
                    className="lists-container"
                    activeKey={`${currentColumn}`}
                    onChange={(key) => {
                        setCurrentColumn(parseInt(key));
                    }}
                    items={columns.map((i, index) => {
                        return {
                            label: i,
                            key: `${index}`,
                            children: <>
                                <ScrollView
                                    className="list-container"
                                    scrollY={true}
                                    onReachBottom={()=>{
                                        loadList(false, currentColumn)
                                    }}
                                    enableBackToTop={true}
                                    scrollWithAnimation={true}
                                >
                                    {dataList[currentColumn].map((item, listItemIndex) => {
                                        return (
                                            <Block>
                                                <CouponItem
                                                    select={false}
                                                    couponInfo={item}
                                                    state={index}
                                                ></CouponItem>
                                            </Block>
                                        )
                                    })}
                                    {isLoading[index] ? (
                                        <Loading
                                            style={{
                                                width: 25,
                                                height: 25,
                                                marginTop: 25,
                                                marginBottom: 25,
                                                opacity: 0.5
                                            }}

                                        ></Loading>
                                    ) : (
                                        ((noMore[index] &&
                                            dataList[index].length > 0) ||
                                            loadFailed[index]) && (
                                            <Block>
                                                <View
                                                    className="loading-tip"
                                                onClick={()=>{
                                                    if(loadFailed[index]){
                                                        loadList(dataList[index].length === 0, index)
                                                    }
                                                }}
                                                >
                                                    {noMore[index]
                                                        ? '没有更多了'
                                                        : '加载失败，点我重试'}
                                                </View>
                                            </Block>
                                        )
                                    )}

                                </ScrollView>
                                {!isLoading[index] &&
                                    !loadFailed[index] &&
                                    dataList[index].length === 0 && (
                                        <EmptyTip
                                            data={{
                                                icon: require("../../images/empty-coupon.png"),
                                                tip: '没有优惠券',
                                                // btn: '前往领券中心',
                                            }}
                                        // emptyBtnClick={this.emptyBtnClick}
                                        ></EmptyTip>
                                    )}
                            </>
                        }
                    })}
                >

                </Tabs>
            </View>
        </View>
        {/*  栏目  */}
        {/* <ScrollView
      scrollX="true"
      className="tab-layout"
      scrollIntoView={
        'tab-' + (currentColumn - 2 > 0 ? currentColumn - 2 : 0)
      }
    >
      {columns.map((item, idx) => {
        return (
          <View
            data-idx={idx}
            id={'tab-' + idx}
            className={
              'tab-layout-item ' + (currentColumn == idx ? 'active' : '')
            }
            onClick={this.switchColumn}
          >
            <Text>{item + ' (' + columnCount[idx] + ')'}</Text>
          </View>
        )
      })}
    </ScrollView> */}
    </View>
}

export default MyCoupon;